import { ReactComponent as IconDataElement } from "@/assets/svgs/data-element-grey.svg";
import { ReactComponent as IconDocument } from "@/assets/svgs/document-grey.svg";
import { ReactComponent as IconPackage } from "@/assets/svgs/icon-eclip-package-card.svg";
import { ReactComponent as IconParticipant } from "@/assets/svgs/participant-solid-small.svg";
import { ReactComponent as IconPinToTop } from "@/assets/svgs/pin-solid-small.svg";
import { ReactComponent as IconComment } from "@/assets/svgs/chat-bubble-small-blue.svg";
import MultiLevelDropDown from "@/components/MultiLevelMenuDropDown/index.js";
import { ToastContext } from "@/context/toast/index.js";
import useModal from "@/hooks/use-modal/index.js";
import packageFolderApi from "@/services/api/packageFolder.js";
import packageApi from "@/services/api/packages.js";
import getDateTime from "@/utils/get-date-time.js";
import { useContext, useEffect, useState } from "react";
import MultiClamp from 'react-multi-clamp';
import { useNavigate } from '@/lib/router-dom'
import MovePackageToFolderModal from "./move-package-to-folder-modal.jsx";
import StatusBadge from "./package-status-badge.jsx";
import { BADGE_STATUS } from "../utils/get-package-status.js";
import CheckboxButton from '@/components/CheckboxButton'
import PropTypes from 'prop-types';

export default function PackageCard({ item, refreshData, setRefreshData, folderId, folderName = "", selectedPackages, setSelectedPackagesInFolder, showCheckBox }) {

	/*=================================================/
		General
	/================================================*/

	const { goTo } = useNavigate();
	const { addToastMessage } = useContext(ToastContext);

	const [isPinned, setIsPinned] = useState(item.pinned);


	const participantsList = item.participants ?? []
	const participantsDisplayedName = participantsList.slice(0, 3)
	const participantHoverName = participantsList.slice(0, 5)

	const folderPackageMenu = [
		// {
		// 	label: "Move to ...",
		// 	submenu: [
		// 		// {
		// 		// 	label: "Package Sharing",
		// 		// 	icon: <IconFolderArrowUp />,
		// 		// 	onClick: (e) => {
		// 		// 		e.stopPropagation();
		// 		// 		movePackage()
		// 		// 	},
		// 		// },
		// 		{
		// 			label: "Folders",
		// 			icon: <IconFolder />,
		// 			onClick: (e) => {
		// 				e.stopPropagation();
		// 				showMovePackageToFolderModal();
		// 			}
		// 		}
		// 	]
		// },
		{
			label: isPinned ? "Unpin" : "Pin",
			onClick: (e) => {
				e.stopPropagation();
				handlePin();
			},
		},
	]

	const packageMenu = [
		// {
		// 	label: "Move to Folder",
		// 	onClick: (e) => {
		// 		e.stopPropagation();
		// 		showMovePackageToFolderModal();
		// 	}
		// },
		{
			label: isPinned ? "Unpin" : "Pin",
			onClick: (e) => {
				e.stopPropagation();
				handlePin();
			},
		},
	]

	const veridaptMenu = [
		{
			label: isPinned ? "Unpin" : "Pin",
			onClick: (e) => {
				e.stopPropagation();
				handlePin();
			},
		}
	]


	/*=================================================/
		Hooks
	/================================================*/

	const {
		visible: isShowMovePackageToFolderModal,
		hide: hideMovePackageToFolderModel,
	} = useModal();

	useEffect(() => {
		setIsPinned(item.pinned);
	}, [item]);

	/*=================================================/
		Functions
	/================================================*/

	const handlePin = async () => {

		const [error] = await packageApi.pinPackage(isPinned ? "unpin" : "pin", {
			eclipId: item.id
		});

		if (error) {
			return addToastMessage(isPinned ? "Pin not removed" : "Pin not added", 'error')
		}

		setRefreshData(!refreshData)

		addToastMessage(
			isPinned ? "Removed pin successfully" : "Pinned successfully",
			"success"
		);
	};

	const handleClick = (e) => {
		if (e.isPropagationStopped()) {
			return;
		}

		if (item?.badge === BADGE_STATUS.receiving) {
			addToastMessage("Receiving package in process", "error");
			return;
		}

		if (item?.badge === BADGE_STATUS.receiveFailed) {
			addToastMessage("Package failed to receive", "error");
			return;
		}

		if (item?.badge === "PACKAGE_DECLINED" && item?.request) {
			addToastMessage("Package Declined", "error");
			return;
		}
		if (item?.badge === "PACKAGE_ACCEPTED") {
			if (item?.type === "RECEIVE") {
				addToastMessage("No data available yet", "error");
				return;
			}
		}
		if (item?.badge === "PACKAGE_REQUESTED") {
			if (item?.type === "RECEIVE") {
				addToastMessage("Receipient has not responded yet", "error");
				return;
			}
			goTo(`/eclip/respond/${item.id}`);
			return;
		}

		goTo(`/package/details/${item.id}`,{ folderName: folderName, folderId: folderId });
	};

	async function movePackage() {
		const [error] = await packageFolderApi.movePackage(item.id, { folderId: null });

		if (error) {
			return addToastMessage('Failed to move the package to Package Sharing.', 'error')
		}

		document.getElementById('reload-eclips')?.click()
		addToastMessage('You have successfully move the Package to Package Sharing.', 'success')
	}

	return (
		<>
			<div
				id="card"
				className="package-card__container"
				draggable
				onDragStart={(ev) => {
					ev.target.style.cursor = "copy";
					ev.dataTransfer.dropEffect = "copy";
					ev.dataTransfer.setData("veridaptPackage", item.isVeridapt);
					ev.dataTransfer.setData("text/plain", item.id);
				}}
			>
				<div className="package-card__action-input">
					{(showCheckBox) ?
						<CheckboxButton
							check={selectedPackages?.findIndex((selection) => selection === item.id) !== -1}
							onChange={() => { setSelectedPackagesInFolder(item.id) }}
							value={item.id}
						/> : <div className="package-card__icon icon--non-veridapt">
							<IconPackage />
						</div>
					}

					<div className="package-folder-card__folder-pin">{isPinned && <IconPinToTop />}</div>

					<div data-testid="side-menu" className="package-card__menu">
						{item.isVeridapt && (
							<MultiLevelDropDown
								menuList={veridaptMenu}
							/>
						)}
						{!item.isVeridapt && (
							<MultiLevelDropDown
								menuList={folderId ? folderPackageMenu : packageMenu}
							/>
						)}
					</div>
				</div>

				<div className="package-card__contents" onClick={handleClick} data-testid="package-card">
					<div className="package-card__package-details">
						<div className="package-card__date-time">{getDateTime(item.modified)}</div>
						<div className="package-card__package-name tooltip">
							<MultiClamp clamp={2}>{item.name}</MultiClamp>
							<span className={"tooltiptext__package-participant-name"}>
								{item.name}
							</span>
						</div>
						<div className="package-card__content-info">
							<div className="package-card__data-element-info tooltip">
								<IconDataElement />
								<span>{String(item?.dataElementsCount).padStart(2, "0")}</span>
								<span className="tooltiptext__package-landing">
									Data element
								</span>
							</div>
							<div className="package-card__attachment-info tooltip">
								<IconDocument />
								<span>{String(item?.attachmentsCount).padStart(2, "0")}</span>
								<span className="tooltiptext__package-landing">
									Attachment
								</span>
							</div>
						</div>
					</div>

					<div className="package-card__participants tooltip">
						<div className="package-card__participant-label ">
							<div className="package-card__participant-icon"><IconParticipant /></div>
							<div className="package-card__participant-title">Participants</div>
						</div>
						<div className="package-card__participants-info">
							<div className="package-card__participants-name">
								{participantsDisplayedName?.map((participant) => <div key={participant.id}><MultiClamp clamp={1}>{participant.name}</MultiClamp></div>)}
								{participantsList?.length === 0 && (<div>No participant</div>)}
							</div>
							{participantsList?.length > 3 && (
								<div className="package-card__participant-count">
									<div className="package-card__participant-count-text">{`+${participantsList?.length - 3} more`}</div>
								</div>
							)}
						</div>
						<span className={participantsList?.length > 0 ? "tooltiptext__package-participant-name" : ''}>
							{participantHoverName?.map((participant) => <div key={participant.id}>{participant.name}</div>)}
							{participantsList?.length > 5 && <div className="package-card__participant-count__tooltip-text">{`...+${participantsList.length - 5} more`}</div>}
						</span>
					</div>
				</div>
				<div className="package-card__status">
					<div className="package-card__status-info">
						<StatusBadge badge={item?.badge} />
						{item?.isNewCommentAvailable && <div className="package-card__comment-icon"><IconComment /></div>}
					</div>
				</div>
			</div>

			<MovePackageToFolderModal
				isVisible={isShowMovePackageToFolderModal}
				hideModal={hideMovePackageToFolderModel}
				packageId={item.id}
			/>
		</>
	);
}

PackageCard.propTypes = {
	item: PropTypes.any,
	refreshData: PropTypes.any,
	setRefreshData: PropTypes.func,
	folderId: PropTypes.string,
	folderName: PropTypes.string,
	selectedPackages: PropTypes.any,
	setSelectedPackagesInFolder: PropTypes.func,
	showCheckBox: PropTypes.bool,
};
